import React, { Component } from "react";

export default class InputNumber extends Component {
	// eslint-disable-next-line react/static-property-placement
	static defaultProps = {
		defaultValue: "",
		onUpdate: (value) => value,
	};

	state = {
		value: this.props?.defaultValue || "",
	};

	componentDidMount() {
		if (this.number) {
			this.number.focus();
		}
	}

	getValue = () => {
		this.props.onUpdate(this.state.value);
	};

	handlerInput = (event) => {
		this.setState({ value: event.currentTarget.value.replace(/\D/g, "") });
	};

	render() {
		return (
			<input
				ref={(node) => {
					this.number = node;
				}}
				key="number"
				type="text"
				className="form-control"
				value={this.state.value}
				onChange={this.handlerInput}
				onBlur={this.getValue}
			/>
		);
	}
}
